import { searchKeys } from '@schibsted-nmp/search-frontend-clients/quest';
import mFinnLinks from '@finn-no/search-mfinn-links';

// src/getSearchPath.ts

// src/auroraPlatform.ts
var getAuroraPath = (searchKey, searchParams) => {
  const urlGenerator = urlGeneratorFactory(searchParams);
  switch (searchKey) {
    case "SEARCH_ID_CAR_USED":
      return urlGenerator("/mobility/search/car");
    case "SEARCH_ID_CAR_PARALLEL_IMPORT":
      return urlGenerator("/mobility/search/car", ["region", "abroad"]);
    case "SEARCH_ID_CAR_MOBILE_HOME":
      return urlGenerator("/mobility/search/car/mobilehome");
    case "SEARCH_ID_BAP_COMMON":
    case "SEARCH_ID_BAP_ALL":
      return urlGenerator("/recommerce/forsale/search");
    case "SEARCH_ID_BOAT_PARTS":
      return urlGenerator("/mobility/search/boat/engine/parts");
    case "SEARCH_ID_BOAT_MOTOR":
      return urlGenerator("/mobility/search/boat/engine");
    case "SEARCH_ID_BOAT_PARTS_MOTOR_WANTED":
      return urlGenerator("/mobility/search/boat/engine", ["sales_form", "wanted"]);
    case "SEARCH_ID_CAR_VAN":
      return urlGenerator("/mobility/search/b2b/van");
    case "SEARCH_ID_CAR_VAN_ABROAD":
      return urlGenerator("/mobility/search/b2b/van", ["region", "abroad"]);
    case "SEARCH_ID_CAR_CARAVAN":
      return urlGenerator("/mobility/search/car/caravan");
    case "SEARCH_ID_BOAT_USED":
      return urlGenerator("/mobility/search/boat");
    case "SEARCH_ID_BOAT_USED_WANTED":
      return urlGenerator("/mobility/search/boat", ["sales_form", "wanted"]);
    case "SEARCH_ID_BOAT_RENT":
      return urlGenerator("/mobility/search/boat", ["sales_form", "rent"]);
    case "SEARCH_ID_MC_USED":
      return urlGenerator("/mobility/search/motorcycle");
    case "SEARCH_ID_MC_SCOOTER":
      return urlGenerator("/mobility/search/scooter");
    case "SEARCH_ID_MC_ATV":
      return urlGenerator("/mobility/search/atv");
    case "SEARCH_ID_MC_SNOWMOBILE":
      return urlGenerator("/mobility/search/snowmobile");
    case "SEARCH_ID_CAR_TRUCK":
      return urlGenerator("/mobility/search/b2b/truck");
    case "SEARCH_ID_CAR_TRUCK_ABROAD":
      return urlGenerator("/mobility/search/b2b/truck", ["region", "abroad"]);
    case "SEARCH_ID_AGRICULTURE_THRESHING":
      return urlGenerator("/mobility/search/b2b/agriculturecombines");
    case "SEARCH_ID_AGRICULTURE_TRACTOR":
      return urlGenerator("/mobility/search/b2b/agriculturetractor");
    case "SEARCH_ID_AGRICULTURE_TOOL":
      return urlGenerator("/mobility/search/b2b/agriculturetools");
    case "SEARCH_ID_CAR_BUS":
      return urlGenerator("/mobility/search/b2b/bus");
    case "SEARCH_ID_CAR_AGRI":
      return urlGenerator("/mobility/search/b2b/construction");
    case "SEARCH_ID_BOAT_DOCK":
      return urlGenerator("/mobility/search/boat/dock");
    case "SEARCH_ID_BOAT_DOCK_WANTED":
      return urlGenerator("/mobility/search/boat/dock", ["sales_form", "wanted"]);
    default:
      throw new Error(`Unknown searchkey: ${searchKey}`);
  }
};
var urlGeneratorFactory = (searchParams) => (url, categorySearchParam) => {
  if (categorySearchParam) {
    const [key, value] = categorySearchParam;
    searchParams.append(key, value);
  }
  const searchParamsString = searchParams.size > 0 ? `?${searchParams.toString()}` : "";
  return `${url}${searchParamsString}`;
};
[...searchKeys];
var getSearchPath = (searchKey, searchParams = new URLSearchParams(), platform = "aurora") => {
  switch (platform) {
    case "aurora":
      return getAuroraPath(searchKey, searchParams);
    case "legacy":
      searchParams.append("filters", "");
      return `/${mFinnLinks(searchKey)}?${searchParams.toString()}`;
    default:
      throw new Error(`Unknown platform: ${platform}`);
  }
};

export { getSearchPath };
